<template>
  <v-card>
    <v-form>
      <v-card-title>
        <span class="headline">View User</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <data-detail-row
            label="Full Name"
            :data="editedItem"
            :valueData="editedItem.fullname"
            noGutters
          />
          <data-detail-row
            label="Username"
            :data="editedItem"
            :valueData="editedItem.username"
            noGutters
          />
          <data-detail-row
            label="Email"
            :data="editedItem"
            :valueData="editedItem.email"
            noGutters
          />
          <data-detail-row
            label="Mobile Phone"
            :data="editedItem"
            :valueData="editedItem.mobile_phone"
            noGutters
          />
          <data-detail-row
            label="Role"
            :data="roleData"
            :valueData="roleData"
            noGutters
          />

          <v-card
            class="my-2 pa-2"
            v-for="(wilayah, index) in componentsWilayah"
            :key="index"
          >
            <v-row noGutters>
              <v-col cols="10" sm="12" class="font-weight-black"
                >Kode Wilayah
              </v-col>
              <v-col cols="12" sm="12">
                {{ wilayah.kode_wilayah + ' - ' + wilayah.nama_wilayah }}
              </v-col>
            </v-row>

            <v-row noGutters>
              <v-col cols="12" sm="12" class="font-weight-black"
                >Kode Pos - Kecamatan, Kota
              </v-col>
              <v-col cols="12" sm="12">
                <v-chip
                  v-if="wilayah.kodepos_all == 1"
                  color="primary"
                  label
                  small
                  class="rounded-xl ma-1"
                >
                  <span> All Kode Pos - Kecamatan, Kota </span>
                </v-chip>
                <v-chip
                  v-else
                  v-for="(kodePos, index) in wilayah.nama_kodepos"
                  :key="index"
                  color="primary"
                  label
                  small
                  class="rounded-xl ma-1"
                >
                  <span>
                    {{ kodePos }}
                  </span>
                </v-chip>
              </v-col>
            </v-row>
          </v-card>

          <data-detail-row
            label="Status"
            :data="editedItem"
            :valueData="editedItem.status_label || ''"
            noGutters
          />
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn color="blue darken-1" text @click="close"> Kembali </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { date } from '../../../../lib/helpers';

export default {
  components: { DataDetailRow: () => import('../../../detail/DataDetailRow.vue') },
  props: ['editedItem'],
  data: () => ({
    componentsWilayah: [],
  }),
  computed: {
    roleData() {
      const role = this.editedItem?.role?.role
        ? this.editedItem.role.role
        : this.editedItem.role;

      return role;
    },
  },
  watch: {
    editedItem: {
      immediate: true,
      handler() {
        this.getWilayah(this.editedItem?.id);
      },
    },
  },
  methods: {
    getWilayah(userId) {
      if (userId) {
        this.$store
          .dispatch('users/getMappingUser', {
            date,
            userId,
          })
          .then((res) => {
            this.componentsWilayah = res;
          });
      }
    },
    close() {
      this.$emit('closeParent');
    },
  },
};
</script>
